export default __webpack_public_path__ + "static/media/cording_type.b55a766d.jpeg";